import { Field } from "./Field";
import { useHighlight } from "../state/highlight";
import { useCadForm } from "./formContext";
export interface SelectProps<T extends string> { id: string; label: string; value: T; options: { value: T; label: string }[]; onChange: (v: T) => void; unit?: string; symbol?: string; hint?: string; /** şema/çizim etiketi anahtarı (odak ve üstüne gelince vurgu) */ dimKey?: string }
export function Select<T extends string>(p: SelectProps<T>): JSX.Element {
  const hot = useHighlight((s) => s.dimKey);
  const setDim = useHighlight((s) => s.setDim);
  const leave = (): void => { if (p.dimKey && useHighlight.getState().dimKey === p.dimKey) setDim(null); };
  const cad = useCadForm();
  const isHot = !!p.dimKey && hot === p.dimKey;
  return (
    <Field label={p.label} htmlFor={p.id} unit={p.unit} symbol={p.symbol} hint={p.hint} hot={isHot}>
      <select id={p.id} className={cad ? "cad-prop-input font-sans" : `input font-sans ${isHot ? "!border-soil ring-2 ring-soil/20" : ""}`} value={p.value} onChange={(e) => p.onChange(e.target.value as T)}
        onFocus={() => { if (p.dimKey) setDim(p.dimKey); }} onBlur={leave} onMouseEnter={() => { if (p.dimKey) setDim(p.dimKey); }} onMouseLeave={leave}>
        {p.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </Field>
  );
}
